import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import type { RawNumberInputProps } from './RawNumberInput'

export const getNumberFormatOptions = (locale: string, decimalScale = 0) => {
  const separators = new Intl.NumberFormat(locale).formatToParts(1000.1)

  return {
    thousandSeparator: separators.find((part) => part.type === 'group')?.value,
    decimalSeparator: separators.find((part) => part.type === 'decimal')?.value,
    decimalScale,
  }
}

export const useNumberFormatOptions = (
  decimalScale: RawNumberInputProps['decimalScale'] = 0,
) => {
  const intl = useIntl()

  return useMemo(
    () => getNumberFormatOptions(intl.locale, decimalScale),
    [decimalScale, intl.locale],
  )
}
